/**
 * Order a dropdown's options so "Others" comes after every real choice.
 *
 * The lists that come from the database (industry, profession, field of study,
 * level of study, school) are ordered by whatever the rows say, and a row added
 * later with the next `sort_order` lands below "Others". This keeps every other
 * option in the order it arrived and moves "Others" to the end — except that a
 * "Prefer not to say" stays after it, since declining is the last choice of all.
 *
 * @template T
 * @param {T[]} options
 * @param {Object} [how]
 * @param {(option: T) => string} [how.labelOf] The option's display text.
 * @param {(option: T) => boolean} [how.isOther] Defaults to a label of "Other"/"Others".
 * @returns {T[]} A new array; `options` is not changed.
 */
export const othersLast = (
  options,
  { labelOf = option => option.label, isOther = option => /^others?$/i.test(labelOf(option)) } = {},
) => {
  const rank = option => {
    if (/^prefer not to say$/i.test(labelOf(option))) return 2;
    return isOther(option) ? 1 : 0;
  };
  return [...options].sort((a, b) => rank(a) - rank(b));
};
